function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.8529 24.3168C38.2738 24.3168 37.8044 24.7886 37.8044 25.3708V34.7301C37.8024 36.4755 36.3956 37.8902 34.6592 37.8923H5.24203C3.50561 37.8902 2.09886 36.4755 2.09681 34.7301V7.26247C2.09886 5.51669 3.50561 4.10236 5.24203 4.1003H14.5507C15.1298 4.1003 15.5991 3.62844 15.5991 3.04624C15.5991 2.46404 15.1298 1.99219 14.5507 1.99219H5.24203C2.34826 1.99548 0.00327627 4.35311 0 7.26247V34.7301C0.00327627 37.6395 2.34826 39.9971 5.24203 40.0004H34.6592C37.553 39.9971 39.898 37.6395 39.9013 34.7301V25.3712C39.9013 24.789 39.4319 24.3168 38.8529 24.3168Z",
  fill: "#1C355E"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.394 18.7703L31.702 3.37939L36.6389 8.34293L21.331 23.7338L16.394 18.7703Z",
  fill: "#1C355E"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.8958 26.245L19.3516 24.7257L15.4069 20.7598L13.8958 26.245Z",
  fill: "#1C355E"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.0022 0.77047C36.9779 -0.256823 35.3197 -0.256823 34.2955 0.77047L33.1836 1.88835L38.1205 6.85188L39.2324 5.734C40.2546 4.70424 40.2546 3.0371 39.2324 2.00734L38.0022 0.77047Z",
  fill: "#1C355E"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.306dbbe9.svg";
export { ForwardRef as ReactComponent };